import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";
import { Trophy, TrendingUp } from "lucide-react";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/leaderboard").then((r) => setRows(r.data)).catch(() => {});
  }, []);

  return (
    <Shell>
      <div className="p-4 sm:p-8 max-w-5xl" data-testid="leaderboard-page">
        <div className="label-xs text-amber flex items-center gap-2"><Trophy size={12} /> WEEKLY_LEADERBOARD</div>
        <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">The Board.</h1>
        <p className="mt-2 text-fg-muted font-mono text-sm">7-day performance · ranked by closes, dials, AI score.</p>

        <div className="mt-8 border border-term bg-raised overflow-x-auto">
          <div className="min-w-[720px]">
          <div className="grid grid-cols-[60px,2fr,1fr,1fr,1fr,1fr] gap-2 px-4 py-3 border-b border-term label-xs">
            <div>RANK</div><div>AGENT</div><div className="text-right">WK DIALS</div><div className="text-right">WK CLOSES</div><div className="text-right">AI SCORE</div><div className="text-right">GOAL %</div>
          </div>
          {rows.length === 0 && <div className="p-12 text-center font-mono text-xs text-fg-muted">No agents to rank yet.</div>}
          {rows.map((r, i) => {
            const isTop = i === 0;
            return (
              <div key={r.user_id} className={`tap-row grid grid-cols-[60px,2fr,1fr,1fr,1fr,1fr] gap-2 px-4 py-4 text-sm font-mono items-center ${isTop ? "is-selected" : ""}`} data-testid={`leaderboard-row-${i+1}`}>
                <div className={`font-display text-2xl ${isTop ? "text-amber" : i < 3 ? "text-fg" : "text-fg-muted"}`}>
                  {isTop && <Trophy size={20} className="inline text-amber mr-1" />}#{i + 1}
                </div>
                <div>
                  <div className="font-bold text-fg">{r.full_name}</div>
                  <div className="text-[10px] text-fg-subtle">{r.email}</div>
                </div>
                <div className="text-right text-fg">{r.week_dials}</div>
                <div className="text-right text-gain font-bold">{r.week_closes}</div>
                <div className={`text-right font-bold ${r.avg_ai_score >= 70 ? "text-gain" : r.avg_ai_score >= 40 ? "text-warn" : "text-fg-muted"}`}>{r.avg_ai_score || "—"}</div>
                <div className="text-right text-amber flex items-center justify-end gap-1">
                  <TrendingUp size={12} /> {r.goal_progress_pct}%
                </div>
              </div>
            );
          })}
          </div>
        </div>
      </div>
    </Shell>
  );
}
